import React from 'react';
import styles from './Legal.module.css';

const Terms: React.FC = () => {
  return (
    <div className={styles.legalContainer}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date: January 1, 2025</strong></p>

      <p>Welcome to "hangjam", a chat, games, and music platform. By accessing or using our platform at hangjam.ai, you agree to be bound by these Terms of Service. Please read these terms carefully before using our services.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using "hangjam", you agree to these Terms of Service and any additional terms that may apply. If you do not agree to these terms, please do not use our platform.</p>

      <h2>2. User Accounts</h2>
      <ul>
        <li>You must be at least 13 years old to use our services.</li>
        <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
        <li>You agree to provide accurate and complete information when creating an account.</li>
        <li>You are solely responsible for all activities that occur under your account.</li>
      </ul>

      <h2>3. User Conduct</h2>
      <p>When using our platform, you agree not to:</p>
      <ul>
        <li>Violate any applicable laws or regulations</li>
        <li>Harass, abuse, or harm other users</li>
        <li>Post or transmit inappropriate, offensive, or illegal content</li>
        <li>Attempt to gain unauthorized access to our systems or other user accounts</li>
        <li>Use our platform for any commercial purposes without our express consent</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <ul>
        <li>All content and materials on "hangjam" are protected by intellectual property rights.</li>
        <li>You may not copy, modify, distribute, or create derivative works without our permission.</li>
        <li>By submitting content to our platform, you grant us a non-exclusive, worldwide license to use, modify, and display that content.</li>
      </ul>

      <h2>5. Third-Party Services</h2>
      <p>Our platform may integrate with third-party services (such as Google and Spotify). Your use of these services is subject to their respective terms and privacy policies.</p>

      <h2>6. Disclaimer of Warranties</h2>
      <p>Our services are provided "as is" without any warranties, express or implied. We do not guarantee that our platform will be uninterrupted, secure, or error-free.</p>

      <h2>7. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our platform.</p>

      <h2>8. Changes to Terms</h2>
      <p>We reserve the right to modify these terms at any time. We will notify users of any material changes through our platform or via email.</p>

      <h2>9. Termination</h2>
      <p>We may terminate or suspend your access to our platform at any time, without prior notice, for any violation of these terms or for any other reason we deem appropriate.</p>

      <h2>10. Contact Information</h2>
      <p>If you have any questions about these Terms of Service, please contact us.</p>
    </div>
  );
};

export default Terms; 